import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
export default function Footer() {
  return <footer style={{
    backgroundColor: 'rgb(26, 46, 32)',
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    color: 'black',
    fontFamily: 'Inter, sans-serif',
    paddingTop: '64px',
    paddingBottom: '32px',
    animation: 'none 0s ease 0s 1 normal none running'
  }} className="!bg-[rgba(255,255,255,1)]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Playfair+Display:wght@700&display=swap');
        .footer-link-service {
          transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1), background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
        }
        .footer-link-service:hover {
          color: black;
          opacity: 1;
        }
        .footer-social-btn {
          transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1), background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
        }
        .footer-social-btn:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
        .footer-bottom-link {
          transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);
        }
        .footer-bottom-link:hover {
          color: black;
          opacity: 1;
        }
      `}</style>

      <div className="page-container">
        <div className="flex flex-col md:flex-row md:justify-between gap-12 md:gap-8">

          <div className="flex flex-col" style={{
          maxWidth: '360px'
        }}>
            <Link to="/" style={{
            border: '0px solid rgb(222, 222, 211)',
            animation: 'none 0s ease 0s 1 normal none running',
            textDecoration: 'none',
            display: 'inline-block'
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/tm-plant-new-logo.png" alt="TM Plant Logo" className="h-7 w-auto" loading="lazy" />
            </Link>

            <p style={{
            color: 'black',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '22.75px',
            border: '0px solid rgb(222, 222, 211)',
            animation: 'none 0s ease 0s 1 normal none running',
            marginTop: '24px',
            marginBottom: '0px'
          }} className="!text-[rgba(0,0,0,1)]">Expert garden machinery servicing and repairs in Carlisle and across Cumbria. We work on all major brands — fast turnarounds, honest pricing, and no unnecessary parts.<div><br /></div></p>

            <div style={{
            marginTop: '24px'
          }}>
              <Link to="#" className="footer-social-btn inline-flex items-center justify-center" style={{
              color: 'black',
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
              borderRadius: '2px',
              border: '0px solid rgb(222, 222, 211)',
              padding: '8px',
              animation: 'none 0s ease 0s 1 normal none running',
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              textDecoration: 'none'
            }}>
                <span dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>`
              }} />
              </Link>
            </div>
          </div>

          <div className="flex flex-col">
            <h3 style={{
            color: 'black',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '20px',
            marginBottom: '16px',
            marginTop: '0px'
          }}>
              Contact Us
            </h3>
            <div className="flex flex-col" style={{
            gap: '16px'
          }}>

              <div className="flex flex-row items-start" style={{
              gap: '12px'
            }}>
                <span style={{
                flexShrink: 0,
                color: 'black',
                display: 'flex',
                alignItems: 'center'
              }} dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>`
              }} />
                <p style={{
                color: 'black',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                border: '0px solid rgb(222, 222, 211)',
                animation: 'none 0s ease 0s 1 normal none running',
                margin: '0'
              }} className="!text-[rgba(0,0,0,1)]">Unit 6 Thomas St, Carlisle CA2 5DZ</p>
              </div>

              <div className="flex flex-row items-center" style={{
              gap: '12px'
            }}>
                <span style={{
                flexShrink: 0,
                color: 'black',
                display: 'flex',
                alignItems: 'center'
              }} dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>`
              }} />
                <p style={{
                color: 'black',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                border: '0px solid rgb(222, 222, 211)',
                animation: 'none 0s ease 0s 1 normal none running',
                margin: '0'
              }}>
                  +44 7537804238
                </p>
              </div>

              <div className="flex flex-row items-center" style={{
              gap: '12px'
            }}>
                <span style={{
                flexShrink: 0,
                color: 'black',
                display: 'flex',
                alignItems: 'center'
              }} dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>`
              }} />
                <p style={{
                color: 'black',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                border: '0px solid rgb(222, 222, 211)',
                animation: 'none 0s ease 0s 1 normal none running',
                margin: '0'
              }}>info@tmplant.co.uk</p>
              </div>

            </div>
          </div>

        </div>

        <div style={{
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        marginTop: '48px',
        paddingTop: '24px'
      }} className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <p style={{
          color: 'black',
          fontFamily: 'Inter, sans-serif',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '20px',
          border: '0px solid rgb(222, 222, 211)',
          animation: 'none 0s ease 0s 1 normal none running',
          margin: '0'
        }}>© 2026 TM Plant. All rights reserved. <Link to="https://zionova.co.uk" newTab>Zionova</Link></p>
          <div className="flex flex-row items-center" style={{
          gap: '24px'
        }}>
            <Link to="#" className="footer-bottom-link" style={{
            color: 'black',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            textDecoration: 'none',
            border: '0px solid rgb(222, 222, 211)',
            textAlign: 'left',
            animation: 'none 0s ease 0s 1 normal none running'
          }}>
              Privacy Policy
            </Link>
            <Link to="#" className="footer-bottom-link" style={{
            color: 'black',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            textDecoration: 'none',
            border: '0px solid rgb(222, 222, 211)',
            textAlign: 'left',
            animation: 'none 0s ease 0s 1 normal none running'
          }}>
              Cookie Notice
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}